<terra-dialog-header>
  <h1 [innerHTML]="data.title"></h1>
</terra-dialog-header>

<mat-dialog-content>
  <ng-template #loader>
    <terra-loader class="loader"></terra-loader>
  </ng-template>

  <div *ngIf="bankAccountDetails$ | async as bankAccountDetails; else loader">

    <ul class="details-list">
      <li *ngIf="bankAccountDetails.nickname" class="details-list-item">
        <span class="label">Nickname</span><span class="value">{{bankAccountDetails.nickname}}</span>
      </li>

      <li *ngIf="bankAccountDetails.holderFullName" class="details-list-item">
        <span class="label">Account holder name</span><span class="value">{{bankAccountDetails.holderFullName}}</span>
      </li>

      <li *ngIf="bankAccountDetails.country?.name" class="details-list-item">
        <span class="label">Country</span><span class="value">{{bankAccountDetails.country?.name}}</span>
      </li>

      <li *ngIf="bankAccountDetails.bankName" class="details-list-item">
        <span class="label">Bank name</span><span class="value">{{bankAccountDetails.bankName}}</span>
      </li>

      <li *ngIf="bankAccountDetails.bankBranchName" class="details-list-item">
        <span class="label">Bank branch name</span><span class="value">{{bankAccountDetails.bankBranchName}}</span>
      </li>

      <li *ngIf="bankAccountDetails.bankBranchCode" class="details-list-item">
        <span class="label">Bank branch code</span><span class="value">{{bankAccountDetails.bankBranchCode}}</span>
      </li>

      <li *ngIf="bankAccountDetails.accountNumber" class="details-list-item">
        <span class="label">Account number</span><span class="value">{{bankAccountDetails.accountNumber | accountNumberToAstrix : 4}}</span>
      </li>

      <li *ngIf="bankAccountDetails.iban" class="details-list-item">
        <span class="label">IBAN</span><span class="value">{{bankAccountDetails.iban}}</span>
      </li>

      <li *ngIf="bankAccountDetails.swift" class="details-list-item">
        <span class="label">SWIFT</span><span class="value">{{bankAccountDetails.swift}}</span>
      </li>

      <li *ngIf="bankAccountDetails.ukSortCode" class="details-list-item">
        <span class="label">UK Sort Code</span><span class="value">{{bankAccountDetails.ukSortCode}}</span>
      </li>

      <li *ngIf="bankAccountDetails.usabaRoutingNumber" class="details-list-item">
        <span class="label">US ABA routing number</span><span class="value">{{bankAccountDetails.usabaRoutingNumber}}</span>
      </li>

      <li *ngIf="bankAccountDetails.fedWireRoutingNumber" class="details-list-item">
        <span class="label">Wire routing number</span><span class="value">{{bankAccountDetails.fedWireRoutingNumber}}</span>
      </li>

      <li *ngIf="bankAccountDetails.ifsc" class="details-list-item">
        <span class="label">IFSC</span><span class="value">{{bankAccountDetails.ifsc}}</span>
      </li>

      <li *ngIf="bankAccountDetails.canadaTransitNumber" class="details-list-item">
        <span class="label">Canada Transit Number</span><span class="value">{{bankAccountDetails.canadaTransitNumber}}</span>
      </li>

      <li *ngIf="bankAccountDetails.canadaInstitutionNumber" class="details-list-item"><span class="label">
          canada Institution Number</span><span class="value">{{bankAccountDetails.canadaInstitutionNumber}}</span>
      
      <li class="details-list-item"><span class="label">
          Payment Method</span><span class="value">{{bankAccountDetails.paymentType | enumString:PaymentType}}</span>
    </ul>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <button mat-flat-button color="primary" class="page-cta" [mat-dialog-close] cdkFocusInitial>Close</button>
</div>
